var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 0.811523C7.02064 0.811523 0.149414 7.68265 0.149414 16.1615H4.78219C4.78219 10.2537 9.58825 5.44424 15.4996 5.44424C21.411 5.44424 26.2171 10.2502 26.2171 16.1615C26.2171 22.0728 21.411 26.8788 15.4996 26.8788L15.4996 31.5115C23.9786 31.5115 30.8499 24.6404 30.8499 16.1615C30.8499 7.68265 23.9786 0.811523 15.4996 0.811523Z",
    fill: "url(#paint0_angular_2943_18173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2943_18173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4996 16.1615) rotate(90) scale(15.35 15.3502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#2FAE7B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#2FAE7B",
    stopOpacity: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FAE7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e6f2560718c274eb19535724fde46efa.svg";
export { ForwardRef as ReactComponent };